import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type Transcriptions_AudioAsset_Fragment = { __typename?: 'AudioAsset', id: string, localeTranscriptions?: { __typename?: 'TranscriptionConnection', nodes: Array<{ __typename?: 'Transcription', id?: string | null, name?: string | null, displayName?: string | null, encodeStatus: Types.EncodeStatusEnum, locale?: any | null, lastEditedAt?: string | null, source?: Types.TranscriptionSource | null, json?: { __typename?: 'TranscriptionUrls', streamUrl?: string | null } | null, vtt?: { __typename?: 'TranscriptionUrls', downloadUrl?: string | null } | null, srt?: { __typename?: 'TranscriptionUrls', downloadUrl?: string | null } | null, text?: { __typename?: 'TranscriptionUrls', downloadUrl?: string | null } | null }> } | null };

export type Transcriptions_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', id: string };

export type Transcriptions_FileAsset_Fragment = { __typename?: 'FileAsset', id: string };

export type Transcriptions_FolderAsset_Fragment = { __typename?: 'FolderAsset', id: string };

export type Transcriptions_ImageAsset_Fragment = { __typename?: 'ImageAsset', id: string };

export type Transcriptions_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', id: string };

export type Transcriptions_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset', id: string };

export type Transcriptions_ModelAsset_Fragment = { __typename?: 'ModelAsset', id: string };

export type Transcriptions_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', id: string };

export type Transcriptions_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset', id: string };

export type Transcriptions_VideoAsset_Fragment = { __typename?: 'VideoAsset', id: string, localeTranscriptions?: { __typename?: 'TranscriptionConnection', nodes: Array<{ __typename?: 'Transcription', id?: string | null, name?: string | null, displayName?: string | null, encodeStatus: Types.EncodeStatusEnum, locale?: any | null, lastEditedAt?: string | null, source?: Types.TranscriptionSource | null, json?: { __typename?: 'TranscriptionUrls', streamUrl?: string | null } | null, vtt?: { __typename?: 'TranscriptionUrls', downloadUrl?: string | null } | null, srt?: { __typename?: 'TranscriptionUrls', downloadUrl?: string | null } | null, text?: { __typename?: 'TranscriptionUrls', downloadUrl?: string | null } | null }> } | null };

export type TranscriptionsFragment = Transcriptions_AudioAsset_Fragment | Transcriptions_DocumentAsset_Fragment | Transcriptions_FileAsset_Fragment | Transcriptions_FolderAsset_Fragment | Transcriptions_ImageAsset_Fragment | Transcriptions_InteractiveAsset_Fragment | Transcriptions_InteractiveLiveAsset_Fragment | Transcriptions_ModelAsset_Fragment | Transcriptions_UnsupportedAsset_Fragment | Transcriptions_VersionStackAsset_Fragment | Transcriptions_VideoAsset_Fragment;

export type TranscriptUrlsFragment = { __typename?: 'Transcription', json?: { __typename?: 'TranscriptionUrls', streamUrl?: string | null } | null, vtt?: { __typename?: 'TranscriptionUrls', downloadUrl?: string | null } | null, srt?: { __typename?: 'TranscriptionUrls', downloadUrl?: string | null } | null, text?: { __typename?: 'TranscriptionUrls', downloadUrl?: string | null } | null };

export const TranscriptUrls = /*#__PURE__*/ gql`
    fragment TranscriptUrls on Transcription {
  json {
    streamUrl
  }
  vtt {
    downloadUrl
  }
  srt {
    downloadUrl
  }
  text(locale: $locale) {
    downloadUrl
  }
}
    ` as unknown as DocumentNode<TranscriptUrlsFragment, unknown>;
export const Transcriptions = /*#__PURE__*/ gql`
    fragment Transcriptions on Asset {
  id
  ... on VideoAsset {
    localeTranscriptions(page: {first: 100}) {
      nodes {
        id
        name
        displayName
        encodeStatus
        ...TranscriptUrls
        locale
        lastEditedAt
        source
      }
    }
  }
  ... on AudioAsset {
    localeTranscriptions(page: {first: 100}) {
      nodes {
        id
        name
        displayName
        encodeStatus
        ...TranscriptUrls
        locale
        lastEditedAt
        source
      }
    }
  }
}
    ${TranscriptUrls}` as unknown as DocumentNode<TranscriptionsFragment, unknown>;

        

        
export const useTranscriptionsFragment = (
  input: string | Omit<UseFragmentOptions<TranscriptionsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<TranscriptionsFragment>({
    fragment: Transcriptions,
    fragmentName: 'Transcriptions',
    ...options,
  });
};
  
        
        

        
export const useTranscriptUrlsFragment = (
  input: string | Omit<UseFragmentOptions<TranscriptUrlsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Transcription' } };
    return input;
  })();

  return useFragment<TranscriptUrlsFragment>({
    fragment: TranscriptUrls,
    fragmentName: 'TranscriptUrls',
    ...options,
  });
};
  
        